module.exports = __webpack_public_path__ + "static/img/channel2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/channel2.png
// module id = 544
// module chunks = 0